import React from "react";
import ReactApexChart from "react-apexcharts";
import useChartColors from "Components/Common/useChartColors";

export const SupportTrendChartNumber = ({ series, categories }: any) => {
  const chartId = "support_trend_chart";
  const ChartColors = useChartColors(chartId);

  const options: any = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    // markers: {
    //     size: 4,
    // },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ChartColors,
    xaxis: {
      categories,
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        id={chartId}
        type="line"
        height="350"
        data-colors='["#088f7d", "#ffa600", "--vz-secondary", "--vz-info", "--vz-success", "--vz-danger"]'
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export const SupportTrendChartAmount = ({ series, categories }: any) => {
  const chartId = "support_trend_chart";
  const MarketplaceChartColors = useChartColors(chartId);

  const options: any = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    // markers: {
    //     size: 4,
    // },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: MarketplaceChartColors,
    xaxis: {
      categories,
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + "M"; // Convert to millions
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + "K"; // Convert to thousands
          }
          return value.toString(); // Return the original value for smaller numbers
        },
      },
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        id={chartId}
        type="line"
        height="350"
        data-colors='["#088f7d", "#ffa600", "--vz-secondary", "--vz-info", "--vz-success", "--vz-danger"]'
        className="apex-charts"
      />
    </React.Fragment>
  );
};
